import { defineRouting } from "next-intl/routing";

// Supported languages. `hy` = Armenian, `ru` = Russian, `en` = English.
export const locales = ["hy", "ru", "en"] as const;
export type Locale = (typeof locales)[number];

export const routing = defineRouting({
  locales,
  defaultLocale: "en",
  // Always show the locale in the URL (e.g. /en, /hy, /ru) for clarity & SEO.
  localePrefix: "always",
  // No HTTP `Link: rel=alternate` header: its x-default pointed at the
  // unprefixed URL (a 307 redirect) and contradicted the HTML hreflang links
  // emitted per page by pageAlternates() — one source of truth is safer.
  alternateLinks: false,
});
